//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import spotlightImage1 from '@images/onboarding/spotlight1.png';
import spotlightImage2 from '@images/onboarding/spotlight2.png';
import spotlightImage3 from '@images/onboarding/spotlight3.png';
import spotlightImage4 from '@images/onboarding/spotlight4.png';
import { FeatureCard } from '@welcome-page/components/onboarding/spotlight/FeatureCard';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

export const FeatureCardGrid = () => {
  return (
    <FeatureGridContainer>
      <FeatureCard
        image={<img src={spotlightImage1} height={95} />}
        items={[
          'Social calendar and scheduler',
          'Social listening',
          'Social inbox',
        ]}
        title={'Social Media Management'}
        seeMoreUrl='https://docs.bazaarvoice.com/articles/vibe/social-management-publishing'
        seeMoreTrackingId={
          ONBOARDING_TRACKING_ID.SPOTLIGHT_SOCIAL_MEDIA_MANAGEMENT_SEE_MORE_BUTTON
        }
      />
      <FeatureCard
        image={<img src={spotlightImage2} height={95} />}
        items={[
          'Cross-platform AI creator search',
          'End-to-end creator campaigns',
          'Full-funnel campaign reporting',
        ]}
        title={'Creator Marketing'}
        seeMoreUrl='https://docs.bazaarvoice.com/articles/vibe/creators'
        seeMoreTrackingId={
          ONBOARDING_TRACKING_ID.SPOTLIGHT_CREATOR_MARKETING_SEE_MORE_BUTTON
        }
      />
      <FeatureCard
        image={<img src={spotlightImage3} height={120} />}
        items={[
          'On-demand campaign requests',
          'Built-in usage rights & product tagging',
          'Full-funnel campaign reporting',
        ]}
        title={'Product Sampling'}
        seeMoreUrl='https://docs.bazaarvoice.com/articles/vibe/vibe-sampling-campaigns'
        seeMoreTrackingId={
          ONBOARDING_TRACKING_ID.SPOTLIGHT_PRODUCT_SAMPLING_SEE_MORE_BUTTON
        }
      />
      <FeatureCard
        image={<img src={spotlightImage4} height={95} />}
        items={[
          'TikTok content sourcing',
          'Content rights expirations',
          'Multi-handle support',
        ]}
        title={'Social Commerce'}
        seeMoreUrl='https://docs.bazaarvoice.com/articles/vibe/commerce'
        seeMoreTrackingId={
          ONBOARDING_TRACKING_ID.SPOTLIGHT_SOCIAL_COMMERCE_SEE_MORE_BUTTON
        }
      />
    </FeatureGridContainer>
  );
};

const FeatureGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, max-content);
  justify-content: space-around;
  grid-gap: 40px;
`;
